import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component,  Inject, OnDestroy, OnInit, Optional, PLATFORM_ID, Renderer2, input } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject, takeUntil } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { MEDIA_TOKEN } from '../../../../../tockens';
@Component({
    selector: 'clever-dauer',
    templateUrl: './dauer.component.html',
    styleUrls: ['./dauer.component.scss'],
    animations: [
        trigger('zoom', [
            state('leftBottom', style({ transform: 'scale(0.3)', transformOrigin: 'left bottom', opacity: '0' })),
            state('default', style({ transform: 'scale(1)', opacity: '1' })),
            transition('* <=> default', animate('10ms cubic-bezier(0.25,1,.25,1)'))
        ])
    ],
    standalone: false
})
export class DauerComponent implements OnInit, OnDestroy {
    readonly mode = input<string>(undefined);
    readonly bottomleftradius = input<boolean>(false);
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    showModal: boolean = false;
    media: string = 'lg';
    origin = 'default';
    zielText = 'Beliebig';
    currentItem: any;
    minDauer: number;
    maxDauer: number;

    section1 = [
        {
            name: 'Beliebig',
            minDuration: '1',
            maxDuration: '30',
        },
        {
            name: 'exakt wie angegeben',
            minDuration: '-1',
            maxDuration: '-1',
        },
        {
            name: '1 Woche',
            minDuration: '7',
            maxDuration: '7',
        },
        {
            name: '2 Wochen',
            minDuration: '14',
            maxDuration: '14',
        },
        {
            name: '3 Wochen',
            minDuration: '21',
            maxDuration: '21',
        },
        {
            name: '4 Wochen',
            minDuration: '27',
            maxDuration: '27',
        },
    ];

    section2 = [
        {
            name: '1 - 4 Tage',
            minDuration: '1',
            maxDuration: '4',
        },
        {
            name: '5 - 8 Tage',
            minDuration: '5',
            maxDuration: '8',
        },
        {
            name: '9 - 12 Tage',
            minDuration: '9',
            maxDuration: '12',
        },
        {
            name: '13 - 16 Tage',
            minDuration: '13',
            maxDuration: '16',
        },
        {
            name: '17 - 22 Tage',
            minDuration: '17',
            maxDuration: '22',
        },
    ];

    section3 = [
        {
            name: '1 Tag',
            minDuration: '1',
            maxDuration: '1',
        },
        {
            name: '2 Tage',
            minDuration: '2',
            maxDuration: '2',
        },
        {
            name: '3 Tage',
            minDuration: '3',
            maxDuration: '3',
        },
        {
            name: '4 Tage',
            minDuration: '4',
            maxDuration: '4',
        },
        {
            name: '5 Tage',
            minDuration: '5',
            maxDuration: '5',
        },
        {
            name: '6 Tage',
            minDuration: '6',
            maxDuration: '6',
        },
        {
            name: '7 Tage',
            minDuration: '7',
            maxDuration: '7',
        },
        {
            name: '8 Tage',
            minDuration: '8',
            maxDuration: '8',
        },
        {
            name: '9 Tage',
            minDuration: '9',
            maxDuration: '9',
        },
        {
            name: '10 Tage',
            minDuration: '10',
            maxDuration: '10',
        },
        {
            name: '11 Tage',
            minDuration: '11',
            maxDuration: '11',
        },
        {
            name: '12 Tage',
            minDuration: '12',
            maxDuration: '12',
        },
        {
            name: '13 Tage',
            minDuration: '13',
            maxDuration: '13',
        },
        {
            name: '14 Tage',
            minDuration: '14',
            maxDuration: '14',
        },
        {
            name: '15 Tage',
            minDuration: '15',
            maxDuration: '15',
        },
        {
            name: '16 Tage',
            minDuration: '16',
            maxDuration: '16',
        },
        {
            name: '17 Tage',
            minDuration: '17',
            maxDuration: '17',
        },
        {
            name: '18 Tage',
            minDuration: '18',
            maxDuration: '18',
        },
        {
            name: '19 Tage',
            minDuration: '19',
            maxDuration: '19',
        },
        {
            name: '20 Tage',
            minDuration: '20',
            maxDuration: '20',
        },
        {
            name: '21 Tage',
            minDuration: '21',
            maxDuration: '21',
        },
        {
            name: '22 Tage',
            minDuration: '22',
            maxDuration: '22',
        },
        {
            name: '23 Tage',
            minDuration: '23',
            maxDuration: '23',
        },
        {
            name: '24 Tage',
            minDuration: '24',
            maxDuration: '24',
        },
        {
            name: '25 Tage',
            minDuration: '25',
            maxDuration: '25',
        },
        {
            name: '26 Tage',
            minDuration: '26',
            maxDuration: '26',
        },
        {
            name: '27 Tage',
            minDuration: '27',
            maxDuration: '27',
        },
        {
            name: '28 Tage',
            minDuration: '28',
            maxDuration: '28',
        },
        {
            name: '29 Tage',
            minDuration: '29',
            maxDuration: '29',
        },
        {
            name: '30 Tage',
            minDuration: '30',
            maxDuration: '30',
        },
    ];

    constructor(
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        protected render: Renderer2,
        protected hotelService: HotelFiltersService,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.media = this.media_token;
    }

    ngOnInit(): void {
        this.initMedia();
        this.initFilterSub();
    }

    initFilterSub() {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            this.initDauer(filter);
        });
    }

    initDauer(filter: ParamFilters) {
        this.zielText = '';
        if (filter?.reisedauerResult?.name?.length > 0 && filter?.reisezeitraumResult.minDuration !== filter?.reisezeitraumResult.maxDuration) {
            if (this.zielText !== filter.reisedauerResult.name) {
                this.zielText = filter.reisedauerResult.name;
            }
        } else if (Number(filter?.reisezeitraumResult?.minDuration) > 0) {
            this.zielText = filter?.reisezeitraumResult.minDuration + '';
            if (filter?.reisezeitraumResult.minDuration !== filter?.reisezeitraumResult.maxDuration) {
                if (Number(filter?.reisezeitraumResult.maxDuration) > 0) {
                    this.zielText += ' - ' + filter?.reisezeitraumResult.maxDuration + ' Tage';
                } else {
                    this.zielText += Number(filter?.reisezeitraumResult?.minDuration) === 1 ? 'Tag' : ' Tage';
                }
            } else {
                this.zielText += Number(filter?.reisezeitraumResult?.minDuration) === 1 ? 'Tag' : ' Tage';
            }
        } else if (Number(filter?.reisezeitraumResult?.minDuration) === -1) {
            this.zielText = 'exakt wie angegeben';
        } else {
            this.zielText = 'Beliebig';
        }

        if (this.zielText === '1 - 99 Tage') {
            this.zielText = 'Beliebig';
        }

        this.cdr.detectChanges();
    }

    initMedia() {
       if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
        this.cdr.detectChanges();
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    openModal(ev) {
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    openModalMobile(ev) {
        // this.render.addClass(document.body, 'model-open');
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    closeModal() {
        this.showModal = false;
        this.cdr.detectChanges();
    }

    closeModalMobile() {
        this.showModal = false;
        // this.render.removeClass(document.body, 'model-open');
        this.cdr.detectChanges();
    }

    zoomin(position: any) {
        this.origin = position;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.origin = 'default';
            this.cdr.detectChanges();
        });
    }

    selectValue(item) {
        this.zielText = item.name;
        this.currentItem = item;
        this.maxDauer = null;
        this.minDauer = null;
        this.hotelService.reisedauerResult({
            name: this.zielText,
            minDuration: this.currentItem.minDuration,
            maxDuration: this.currentItem.maxDuration,
        })
        this.closeModal();
    }

    selected() {
        if (this.minDauer && this.maxDauer) {
            this.zielText = this.minDauer + ' - ' + this.maxDauer + ' Tage';
        } else {
            this.zielText = 'Beliebig';
        };

        this.hotelService.reisedauerResult({
            name: this.zielText,
            minDuration: this.minDauer ? this.minDauer : this.currentItem.minDuration,
            maxDuration: this.maxDauer ? this.maxDauer : this.currentItem.maxDuration,
        })
        this.closeModal();
    }
}
